import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core'

import { WorkspaceType } from '@flowx/designer/modules/workspaces/shared/commons.types'

@Component({
  selector: 'flx-workspace-env-type-tag',
  changeDetection: ChangeDetectionStrategy.Eager,
  template: `
    <div
      [class]="styleClass()"
      class="w-fit px-2 rounded-2xl text-neutral-50 text-xs/[18px] font-semibold"
    >
      {{ name() }}
    </div>
  `,
})
export class WorkspaceEnvTypeTagComponent {
  envType = input.required<WorkspaceType>()
  name = input.required<string>()

  backgroundColor = computed(() => {
    const envType = this.envType()

    return (
      {
        [WorkspaceType.SANDBOX]: 'bg-blue-500',
        [WorkspaceType.STAGING]: 'bg-yellow-500',
        [WorkspaceType.PRODUCTION]: 'bg-neutral-700',
      }[envType] || 'bg-neutral-100'
    )
  })

  textColor = computed(() => {
    const envType = this.envType()

    return (
      {
        [WorkspaceType.STAGING]: 'text-neutral-800',
      }[envType] || 'text-neutral-50'
    )
  })

  styleClass = computed(() => {
    const backgroundColor = this.backgroundColor()
    const textColor = this.textColor()
    return `${backgroundColor} ${textColor}`
  })
}
